<style scoped>
ul {
  list-style: none;
  padding-left: 1em;
}


</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { notify } from '@/helpers/notify' 


export default {
    page: {
        title: "Yetkilendirmeler",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "YETKİLENDİRMELER",
            form: [],
            list: {},
            group_name: '',
            abilities: {},
            submitted:false,
            items: [ { text: "ANASAYFA", href: "/" }, { text: "YETKİLENDİRMELER", active: true } ],
            collapse:null,
            update_id:null
        };
    },
    created(){
        this.$http.post(`/abilites`)
        .then(response => this.abilities = response.data)

        this.$http.get(`/abilites/groups`)
        .then(response => this.list = response.data)
    },
    methods:{
        check({target}, id){
            if(target.checked){
                this.form.push(id)
            }else{
                this.form = this.form.filter(e=> e != id)
            }
        },
        update(idx){
            this.form = []
            this.group_name = this.list[idx].name
            this.update_id = this.list[idx].id
            this.list[idx].abilities.map(e =>{
                this.form.push(e.id)
            })
            this.collapse = 0
        },
        handle(yeni) {
            this.submitted = true;
            let new_data = (yeni ? true : false);

            this.$http.post('/abilites/store', { abilites:this.form, new_data, update_id:this.update_id, group_name:this.group_name})
            .then(response => {
                this.submitted = false;
                if(response.data.error){
                    return notify.error(response.data.message)
                }
                return notify.success(response.data.message)
            })
            .error(e=>e)
        },
        _collapse(idx){
            if(this.collapse == idx ){
                this.collapse = null
            }else{
                this.collapse = idx
            }
        },
        tumunuTemizle(){
            this.form = []
        },
        altsec(idx){
            this.abilities[idx].sub.map(e =>{
                this.form.push(e.id)
            })
            this.form.push(this.abilities[idx].id)
        },
        alttemizle(idx){
            let idsToRemove = this.abilities[idx].sub.map(e => e.id);
            idsToRemove.push( this.abilities[idx].id)
            this.form = this.form.filter(id => !idsToRemove.includes(id));
        }
    },
};
</script>

<template>
<Layout>
  <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-5">
          <div class="card">
              <div class="card-body">
                  <div class="row">
                        <div class="col-md-12">
                            <span @click="tumunuTemizle()">Tümünü Temizle</span>
                            <ul class="file-tree" style="padding-left: 0;">
                                <li v-for="(ablty,i) in abilities" :key="i" style="padding:3px; 2px;border:solid 1px #0000002b;border-radius:5px;margin:5px 0px">
                                    <button @click="_collapse(i)" class="btn btn-outline-secondary btn-sm" style="margin:0px 5px">{{ collapse== i ? '-' : '+' }}</button>
                                    <span class="folder"> 
                                        <input type="checkbox" :checked="form.includes(ablty.id)" @input="check($event, ablty.id)" :id="`id${i}`" />
                                        <label :for="`id${i}`" style="margin-bottom:0px;margin-left:5px">{{ ablty.title }}</label>
                                        <button class="btn btn-sm btn-outline-primary float-end" @click="altsec(i)"> Altların Tümünü Seç</button> 
                                        <button class="btn btn-sm btn-outline-danger float-end" @click="alttemizle(i)"> Altların Tümünü Kaldır</button> 
                                    </span>
                                    <ul v-if="collapse == i" style="margin-left:50px">
                                        <li v-for="(sub, d) in ablty.sub" :key="d">
                                            <div>
                                               <span class="file" >
                                                    <input type="checkbox" :checked="form.includes(sub.id)" @input="check($event, sub.id)" :id="`file${d}`"/>
                                                    <label :for="`file${d}`" style="margin-bottom: 0.2rem;margin-left:5px">{{ sub.title }}</label>
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-12 mb-2">
                            <div class="input-group mb-3">
                                <input type="text" v-model="group_name" class="form-control" placeholder="Yetkilere bir isim verin" />
                                <div class="input-group-append">
                                   <button class="btn btn-warning" @click="handle()" type="button" v-if="update_id">Güncelle</button>
                                   <button class="btn btn-success" @click="handle(true)" type="button">Yeni Kaydet</button>
                                </div>
                            </div>
                        </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="col-md-7">
        <div class="card">
            <div class="card-body">
                <div class="row d-flex flex-wrap mb-1">
                    <div class="responsive-table">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Grup Adı</th>
                                    <th>Yetki Sayısı</th>
                                    <th style="width:25px"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(prt, i) in list" :key="i">
                                    <td>{{ prt.name }}</td>
                                    <td>{{ prt.abilities.length }}</td>
                                    <td><button class="btn btn-warning" @click="update(i)">Güncelle</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <!-- end row-->
  </Layout>
</template>